import getLandmarkForPercentageOfDocument from '../getLandmarkForPercentageOfDocument';

/**
 * @method getMarkerForPercentageOfDocument
 */
const getMarkerForPercentageOfDocument = (
  frame,
  document,
  percentageOfDocument,
) => {
  return getLandmarkForPercentageOfDocument(
    frame,
    document,
    percentageOfDocument,
    'markers',
  );
};

export default getMarkerForPercentageOfDocument;
